import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

if (document.getElementsByClassName('recipes-section__slider')[0]) {
  const recipesSlidersArr = document.querySelectorAll(
    '.recipes-section__slider'
  );
  recipesSlidersArr.forEach((sliderEl, sliderIdx) => {
    /*const slides = sliderEl.querySelectorAll('.swiper-slide');
    let loop = false;
    let loopedSlides = false;

    if (slides.length >= 4) {
      loop = true;
      loopedSlides = slides.length * 4;
    }*/

    let pauseOnMouseEnter = window.innerWidth > 1024;

    const recipesSwiper = new Swiper(sliderEl, {
      modules: [Autoplay, Navigation],
      slidesPerView: 1,
      spaceBetween: 20,
      threshold: 10,
      /*loop: loop,
      loopedSlides: loopedSlides,*/
      /*autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: pauseOnMouseEnter,
      },*/
      navigation: {
        prevEl: sliderEl.querySelector('.slider-buttons .slider-btn.prev'),
        nextEl: sliderEl.querySelector('.slider-buttons .slider-btn.next'),
      },
      breakpoints: {
        360: {
          spaceBetween: 12,
          slidesPerView: 1.025,
        },
        451: {
          spaceBetween: 20,
          slidesPerView: 1.5,
        },
        651: {
          spaceBetween: 16,
          slidesPerView: 2,
        },
        901: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
        1025: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
        1200: {
          spaceBetween: 16,
          slidesPerView: 3,
        },
      },
    });

    /*swiperObserver(recipesSwiper);*/
  });
}
